export const onFileUploadChange = (event: any, field: any) => {
  const fileInput = event.target
  if (!fileInput.files) {
    alert("No file was chosen")
    return
  }
  if (!fileInput.files || fileInput.files.length === 0) {
    alert("Files list is empty")
    return
  }
  const file = fileInput.files[0]
  /** Setting file state */
  field.setValue(file) // we will use the file state, to send it later to the server
}

export const uploadFile = async (file: any) => {
  if (!file) {
    return
  }
  var formData = new FormData()
  formData.append("file", file)
  const value = await fetch("/api/upload", {
    method: "POST",
    body: formData,
  })
  //get status
  if (value) {
    return value.json()
  }
}

export const uploadPicture = async (file: any, picture: string, id: string) => {
  if (!file) {
    return
  }
  var formData = new FormData()
  formData.append("file", file)
  formData.append("picture", picture)
  formData.append("id", id)
  const value = await fetch("/api/uploadpicture", {
    method: "POST",
    body: formData,
  })
  if (value) {
    return value.json()
  }
}

export const uploadSupport = async (file: any, support: string, id: string) => {
  if (!file) {
    return
  }
  console.log(file)
  var formData = new FormData()
  formData.append("file", file)
  formData.append("support", support)
  formData.append("id", id)
  const value = await fetch("/api/uploadsupport", {
    method: "POST",
    body: formData,
  })
  if (value) {
    return value.json()
  }
}
